<template>
  <v-container fluid>
    <Header title="Môj účet" subtitle="Nastavenie účtu" />
    <v-layout row wrap align-center justify-center v-if="account">
      <v-flex lg5 md8 xs12>
        <v-form>
          <v-card flat color="transparent">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-validate="'required'" data-vv-as="Meno a priezvisko (názov firmy)"
                    :error-messages="errors.collect('firstName')" prepend-icon="person" name="firstName"
                    label="Meno a priezvisko (názov firmy)" type="text" v-model="account.name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-validate="'required'" data-vv-as="Prihlasovací email"
                    :error-messages="errors.collect('email')" prepend-icon="email" name="email"
                    label="Prihlasovací email" type="email" disabled v-model="account.personIdentity.email">
                  </v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field v-validate="'required|email'" data-vv-as="Kontaktný email"
                    :error-messages="errors.collect('contactEmail')" prepend-icon="email" name="contactEmail"
                    label="Kontaktný email" type="email" v-model="account.contactEmail"></v-text-field>
                </v-flex>

                <!-- <v-flex xs12>
                  <location-searcher :currentLocation="account.address" v-on:locations="updateLocation" />
                </v-flex> -->

                <v-flex xs12>
                  <v-text-field v-validate="'required'" data-vv-as="Kontaktný telefón"
                    :error-messages="errors.collect('phoneNumber')" prepend-icon="phone" name="phoneNumber"
                    label="Kontaktný telefón" type="text" v-model="account.phoneNumber"></v-text-field>
                </v-flex>

                <v-flex xs4>
                  <v-text-field v-validate="" data-vv-as="IČO" :error-messages="errors.collect('ico')"
                    prepend-icon="business" name="ico" label="IČO" type="text" v-model="account.ico"></v-text-field>
                </v-flex>

                <v-flex xs4>
                  <v-text-field v-validate="" data-vv-as="DIČ" :error-messages="errors.collect('dic')"
                    prepend-icon="business" name="dic" label="DIČ " type="text" v-model="account.dic"></v-text-field>
                </v-flex>

                <v-flex xs4>
                  <v-text-field v-validate="" data-vv-as="IČ DPH" :error-messages="errors.collect('icDph')"
                    prepend-icon="business" name="icDph" label="IČ DPH" type="text" v-model="account.icDph">
                  </v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field v-validate="" data-vv-as="Swift" :error-messages="errors.collect('swift')"
                    prepend-icon="account_balance" name="swift" label="Swift" type="text" v-model="account.swift">
                  </v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field v-validate="" data-vv-as="Iban" :error-messages="errors.collect('iban')"
                    prepend-icon="account_balance" name="iban" label="Iban" type="text" v-model="account.iban">
                  </v-text-field>
                </v-flex>

              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.prevent="submit">
                Uložiť
                <span slot="loader" class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
  import Header from '@/components/widgets/Header'
  import AccountService from '@/services/AccountService'
  import LocationSearcher from '@/components/widgets/LocationSearcher'

  import Controller from '@/mixins/controlsMixins'

  export default {
    name: 'PersonalAccount',
    components: {
      Header,
      LocationSearcher
    },
    mixins: [
      Controller
    ],
    data() {
      return {
        account: null
      }
    },
    created() {
      this.loadAccount()
    },
    methods: {
      loadAccount() {
        this.openGlobalLoader('Načítava sa ...')
        new AccountService()
          .getPersonIdentity()
          .then(response => {
            //console.log(response.data);
            this.account = response.data
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            this.closeGlobalLoader()
          });
      },
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.openGlobalLoader('Ukladá sa ...')
            new AccountService()
              .putPersonIdentity(this.account)
              .then(() => {
                console.info('Account updated.');
              })
              .catch(e => {
                console.error(e)
              })
              .finally(() => {
                this.closeGlobalLoader()
                this.loadAccount()
              })
          }
        })
      },
      // updateLocation(data) {
      //   this.account.address = data
      // }
    }
  }
</script>

<style>
</style>